import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AgentPermissionsState, AgentPermissionsActions } from "./types";
import { PersistentStorageKey } from "../common";

export const useAgentPermissionsStore = create(
	persist<AgentPermissionsState & AgentPermissionsActions>(
		(set) => ({
			isActive: false,
			hasOutboundRights: false,
			isSupervisor: false,
			isAdmin: false,
			hasOperatorRights: false,
			hasParkingRight: false,
			hasAllInteractionVisibilityRight: false,
			update: (permissions) =>
				set({
					isActive: permissions.isActive,
					hasOutboundRights: permissions.hasOutboundRights,
					isSupervisor: permissions.isSupervisor,
					isAdmin: permissions.isAdmin,
					hasOperatorRights: permissions.hasOperatorRights,
					hasParkingRight: permissions.hasParkingRight,
					hasAllInteractionVisibilityRight: permissions.hasAllInteractionVisibilityRight,
				}),
		}),
		{
			name: PersistentStorageKey.Permissions, // storage key in localStorage
		}
	)
);
